import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20mysterious%20urban%20alley%20at%20night%20with%20neon%20signs%20and%20dramatic%20shadows%2C%20cinematic%20noir%20atmosphere%2C%20anonymity%20and%20secrecy%20theme%2C%20atmospheric%20fog%20with%20warm%20accent%20lighting%2C%20editorial%20photography%20with%20high%20contrast%2C%20urban%20mystery%20aesthetic&width=1800&height=900&seq=hero-bg-heiliao&orientation=landscape"
          alt="黑料社区 - 深度揭秘平台"
          title="黑料社区 - 深度揭秘与内幕情报聚合平台"
          className={`w-full h-full object-cover`}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/70 via-background-50/50 to-background-50"></div>
      </div>

      {/* Content */}
      <div className="relative w-full container-custom">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-primary-500/15 border border-primary-500/20 rounded-full mb-6">
            <div className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></div>
            <span className="text-primary-400 text-sm font-medium">实时情报聚合中</span>
          </div>

          <h1 className="font-heading font-black text-4xl md:text-5xl lg:text-6xl text-foreground-50 leading-tight mb-6 text-balance">
            发现被隐藏的
            <span className="text-primary-400">真相</span>
            ，掌握第一手
            <span className="text-primary-400">内幕</span>
          </h1>

          <p className="text-foreground-400 text-base md:text-lg leading-relaxed mb-8 max-w-2xl mx-auto">
            黑料社区是专注于深度内幕、真实情报与用户自发揭秘的聚合社区平台。
            在这里，数百万人共同挖掘那些不为人知的内幕故事，让每一个爆料都被认真对待。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/corporate-insider"
              className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-950 rounded-lg font-semibold text-base transition-all duration-200 whitespace-nowrap"
            >
              <i className="ri-compass-3-line mr-2 w-5 h-5 inline-flex items-center justify-center align-middle"></i>
              开始探索
            </Link>
            <Link
              to="/about"
              className="w-full sm:w-auto px-8 py-3.5 bg-background-100/80 hover:bg-background-100 text-foreground-200 rounded-lg font-medium text-base transition-all duration-200 border border-background-200/60 whitespace-nowrap"
            >
              <i className="ri-information-line mr-2 w-5 h-5 inline-flex items-center justify-center align-middle"></i>
              了解更多
            </Link>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-14">
            {[
              { value: "3,200,000+", label: "注册用户" },
              { value: "12,800+", label: "独家爆料" },
              { value: "5,600+", label: "深度调查" },
              { value: "890,000+", label: "活跃讨论" },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="font-heading font-bold text-2xl md:text-3xl text-foreground-100 mb-1">
                  {stat.value}
                </div>
                <div className="text-foreground-500 text-xs md:text-sm">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}